const DEFAULT_BACKEND_ORIGIN = 'http://localhost:5001';

/** Absolute API base including `/api` suffix (works with CRA proxy when relative). */
export const getApiBaseUrl = (): string => {
  const configured = process.env.REACT_APP_API_URL || `${DEFAULT_BACKEND_ORIGIN}/api`;
  if (configured.startsWith('http://') || configured.startsWith('https://')) {
    return configured.replace(/\/$/, '');
  }
  return configured.startsWith('/') ? configured : `/${configured}`;
};

/**
 * Backend origin for Socket.IO and absolute media URLs.
 * When REACT_APP_API_URL is `/api` (CRA proxy), WebSocket must target the backend directly.
 */
export const getBackendOrigin = (): string => {
  const explicit =
    process.env.REACT_APP_BACKEND_URL || process.env.REACT_APP_SOCKET_URL;
  if (explicit) {
    return explicit.replace(/\/$/, '');
  }

  const configured = process.env.REACT_APP_API_URL || `${DEFAULT_BACKEND_ORIGIN}/api`;
  if (configured.startsWith('http://') || configured.startsWith('https://')) {
    return configured.replace(/\/api\/?$/, '');
  }

  return DEFAULT_BACKEND_ORIGIN;
};

export const resolveAbsoluteApiPath = (path: string): string => {
  if (!path) return '';
  if (path.startsWith('http://') || path.startsWith('https://')) return path;

  const apiBase = getApiBaseUrl();
  if (apiBase.startsWith('http://') || apiBase.startsWith('https://')) {
    const origin = apiBase.replace(/\/api\/?$/, '');
    return `${origin}${path.startsWith('/') ? path : `/${path}`}`;
  }

  // Relative `/api` — use backend origin for uploads/socket-adjacent assets
  const origin = getBackendOrigin();
  return `${origin}${path.startsWith('/') ? path : `/${path}`}`;
};
